export const MAX_DESCRIPTION_SIZE = 250;